import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MetaCallbackPage() {
  const navigate = useNavigate();
  const { authFetch, loading, user } = useAuth();
  const [status, setStatus] = useState({ state: 'working', message: 'Confirmando conexión con Meta…' });

  useEffect(() => {
    if (loading) return;
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error') || params.get('error_description');
    if (error) { setStatus({ state: 'error', message: `Meta devolvió un error: ${error}` }); return; }
    if (!code || !state) { setStatus({ state: 'error', message: 'Faltan parámetros de Meta en la URL.' }); return; }
    if (!user) { navigate(`/login?next=${encodeURIComponent(window.location.pathname + window.location.search)}`); return; }
    (async () => {
      try {
        const res = await authFetch(`${API}/social/meta/oauth/exchange`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code, state }) });
        const json = await res.json();
        if (!res.ok) throw new Error(json.detail || 'No se pudo conectar');
        setStatus({ state: 'ok', message: 'Instagram y Facebook conectados correctamente. Redirigiendo…' });
        // If opened as popup → notify parent and close
        if (window.opener && !window.opener.closed) {
          try { window.opener.postMessage({ type: 'META_OAUTH_SUCCESS' }, '*'); } catch (_) {}
          setTimeout(() => window.close(), 1200);
        } else {
          // Determine best redirect for the user's role
          const dest = user?.role === 'admin' ? (json.redirect || '/admin/redes') : '/mlm/panel';
          setTimeout(() => navigate(dest), 1200);
        }
      } catch (err) {
        setStatus({ state: 'error', message: err.message });
      }
    })();
  }, [loading, user, authFetch, navigate]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#02040A] px-4 text-white" data-testid="meta-callback-page">
      <div className="max-w-md rounded-[28px] border border-white/10 bg-white/[0.04] p-8 text-center">
        <p className="text-[11px] font-bold uppercase tracking-[0.35em] text-[#00d4ff]">Meta · Neuralia369</p>
        <h1 className="mt-3 text-2xl font-black">{status.state === 'ok' ? 'Conectado' : status.state === 'error' ? 'No se pudo conectar' : 'Un momento…'}</h1>
        <p className="mt-3 text-sm text-slate-300" data-testid="meta-callback-message">{status.message}</p>
        {status.state === 'error' && <button type="button" onClick={() => navigate(-2)} className="mt-5 rounded-full bg-white px-5 py-2 text-sm font-bold text-slate-900" data-testid="meta-callback-back">Volver</button>}
      </div>
    </main>
  );
}
